import { GetServerSideProps } from "next";
import HeadTermHub from "@/components/hub/HeadTermHub";
import { HUB_CONFIGS } from "@/config/hubPages";

const config = HUB_CONFIGS["weights-gg-alternative"];

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  initialModels: any[];
}

export default function WeightsAlternativePage({ initialModels }: Props) {
  return <HeadTermHub config={config} initialModels={initialModels} />;
}

export const getServerSideProps: GetServerSideProps = async ({ res }) => {
  res.setHeader(
    "Cache-Control",
    "public, s-maxage=600, stale-while-revalidate=1200",
  );
  try {
    const { fetchTopHubModels } = await import("@/utils/hubModels");
    const initialModels = await fetchTopHubModels(24);
    return { props: { initialModels } };
  } catch (error) {
    console.error("Hub SSR error (weights-gg-alternative):", error);
    return { props: { initialModels: [] } };
  }
};
